import maximize from './maximize.svg';
import minimize from './minimize.svg';

export default {
  maximize,
  minimize,
};
